import {ASync} from "../PA.Core/Basic/ASync";
import {IPolicy} from "../PA.Core/PA.Core.IF.Policy";
import {BehaviorSubject} from "rxjs";
import * as _ from 'lodash'
import {SubjectAreaBO} from "./SubjectAreaBO";
import {WB_SubjectAreaRow} from "../PA.Core/PAdbSchemaRows";
import {PAEntity} from "../PA.Core/PAEntity";

export class SubjectAreaPolicy
    implements IPolicy {
    _subjectArea: SubjectAreaBO
    _subjectAreaRow: WB_SubjectAreaRow
    _PolicyChanged: BehaviorSubject<IPolicy>
    _bGenerateInd: boolean
    _bCustomerInd: boolean
    _bCustomerRelInd: boolean
    _bCustomerSrcInd: boolean
    _bSupplyDirectionInd: boolean
    _bProdctGroupInd: boolean
    _bPeriodInd: boolean
    _bGLAccountInd: boolean
    _bEventTypeInd: boolean
    _bEventSpendTypeInd: boolean
    _bFundTypeInd: boolean
    _bDeletedInd: boolean
    _bSnapShotInd: boolean
    _bPlanHierInd: boolean
    _isLoaded: boolean

    constructor(subjectArea: SubjectAreaBO) {
        this._subjectArea = subjectArea
        this._subjectAreaRow = subjectArea.WB_SubjectArea
        this._PolicyChanged = new BehaviorSubject<IPolicy>(this)
        this._bGenerateInd = false
        this._bCustomerInd = false
        this._bCustomerRelInd = false
        this._bCustomerSrcInd = false
        this._bSupplyDirectionInd = false
        this._bProdctGroupInd = false
        this._bPeriodInd = false
        this._bGLAccountInd = false
        this._bEventTypeInd = false
        this._bEventSpendTypeInd = false
        this._bFundTypeInd = false
        this._bDeletedInd = false
        this._bSnapShotInd = false
        this._bPlanHierInd = false
        this._isLoaded = false
    }

    get OnLoadComplete(): Promise<void> {
        const self = this

        if (self._isLoaded) {
            return ASync.resolve()
        }

        return new Promise<any>((resolve, error) => {
            self._subjectArea.OnLoadComplete
                .then((ignore) => {

                    let paEntity = new PAEntity()

                    return paEntity.checkSubjectAreaExists(this._subjectAreaRow.cif.WB_SUBJECTAREA_ID)
                })
                .then((tableExist) => {
                    if (tableExist) {
                        // this._bCustomerInd = getBooleanIndicator(this, 'CUSTOMER_IND')
                        self._bCustomerInd = ((self._subjectAreaRow.cif.CUSTOMER_IND) === '1' || (self._subjectAreaRow.cif.CUSTOMER_IND) === '0')
                        self._bGenerateInd = ((self._subjectAreaRow.cif.GENERATE_IND) === '1' || (self._subjectAreaRow.cif.GENERATE_IND) === '0')
                        self._bCustomerRelInd = ((self._subjectAreaRow.cif.CUSTOMER_REL_IND) === '1' || (self._subjectAreaRow.cif.CUSTOMER_REL_IND) === '0')
                        self._bCustomerSrcInd = ((self._subjectAreaRow.cif.CUSTOMER_SRC_IND) === '1' || (self._subjectAreaRow.cif.CUSTOMER_SRC_IND) === '0')
                        self._bSupplyDirectionInd = ((self._subjectAreaRow.cif.SUPPLYDIRECTION_IND) === '1' || (self._subjectAreaRow.cif.SUPPLYDIRECTION_IND) === '0')
                        self._bProdctGroupInd = ((self._subjectAreaRow.cif.PRODUCTGROUP_IND) === '1' || (self._subjectAreaRow.cif.PRODUCTGROUP_IND) === '0')
                        self._bPeriodInd = ((self._subjectAreaRow.cif.PERIOD_IND) === '1' || (self._subjectAreaRow.cif.PERIOD_IND) === '0')
                        self._bGLAccountInd = ((self._subjectAreaRow.cif.GLACCOUNT_IND) === '1' || (self._subjectAreaRow.cif.GLACCOUNT_IND) === '0')
                        self._bEventTypeInd = ((self._subjectAreaRow.cif.EVENT_TYPE_IND) === '1' || (self._subjectAreaRow.cif.EVENT_TYPE_IND) === '0')
                        self._bEventSpendTypeInd = ((self._subjectAreaRow.cif.EVENT_SPEND_TYPE_IND) === '1' || (self._subjectAreaRow.cif.EVENT_SPEND_TYPE_IND) === '0')
                        self._bFundTypeInd = ((self._subjectAreaRow.cif.FUND_TYPE_IND) === '1' || (self._subjectAreaRow.cif.FUND_TYPE_IND) === '0')
                        self._bSnapShotInd = ((self._subjectAreaRow.cif.SNAPSHOT_IND) === '1' || (self._subjectAreaRow.cif.SNAPSHOT_IND) === '0')
                        self._bPlanHierInd = ((self._subjectAreaRow.cif.PLAN_HIER_IND) === '1' || (self._subjectAreaRow.cif.PLAN_HIER_IND) === '0')
                        self._bDeletedInd = ((self._subjectAreaRow.cif.DELETED_IND) === '1' || (self._subjectAreaRow.cif.DELETED_IND) === '0')

                    } else {
                        self._bCustomerInd = true
                        self._bGenerateInd = true
                        self._bCustomerRelInd = true
                        self._bCustomerSrcInd = true
                        self._bSupplyDirectionInd = true
                        self._bProdctGroupInd = true
                        self._bPeriodInd = true
                        self._bGLAccountInd = true
                        self._bEventTypeInd = true
                        self._bEventSpendTypeInd = true
                        self._bFundTypeInd = true
                        self._bDeletedInd = true
                        self._bSnapShotInd = true
                        self._bPlanHierInd = true
                        self._isLoaded = true
                    }
                    self._PolicyChanged.next(self)
                    resolve(self)
                })
                .catch((err) => {
                    error(err)
                })


        })


    }


    // Add Editbility/ Visibility Properties for all the Elements of an Event
    get bGenerateIndEnabled(): boolean {
        return !this._bGenerateInd;
    }

    get bPlanHierIndEnabled(): boolean {
        return !this._bPlanHierInd;
    }

    get bCustomerIndEnabled(): boolean {
        return !this._bCustomerInd;

    }

    get bSnapShotEnabled(): boolean {
        return !this._bSnapShotInd;

    }

    get bCustomerRelIndEnabled(): boolean {
        return !this._bCustomerRelInd
    }

    get bCustomerSrcIndEnabled(): boolean {
        return !this._bCustomerSrcInd
    }

    get bSupplyDirectionIndEnabled(): boolean {
        return !this._bSupplyDirectionInd
    }

    get bProdctGroupIndEnabled(): boolean {
        return !this._bProdctGroupInd
    }

    get bPeriodIndEnabled(): boolean {
        return !this._bPeriodInd
    }

    get bGLAccountIndEnabled(): boolean {
        return !this._bGLAccountInd
    }

    get bEventTypeIndEnabled(): boolean {
        return !this._bEventTypeInd
    }

    get bEventSpendTypeIndEnabled(): boolean {
        return !this._bEventSpendTypeInd
    }

    get bFundTypeIndEnabled(): boolean {
        return !this._bFundTypeInd
    }

    get bDeletedIndEnabled(): boolean {
        return !this._bDeletedInd
    }

    get bSourceNameEnabled(): boolean {
        let sourceName = this._subjectAreaRow.cif.SOURCE_NAME
        return _.isEmpty(sourceName);
    }

    get PolicyChanged(): BehaviorSubject<IPolicy> {
        return this._PolicyChanged
    }


}


